






















import Vue from 'vue'
import XFormLabel from '@/components/atoms/FormLabel/XFormLabel.vue'
import Panel from './Panel.vue'
import StorePicker from '../../StorePicker/StorePicker.vue'

export type Input = {
  storeId?: string
}

type Data = {
  input: Input
}

type Computed = {
  localValue: Input
}

type Props = {
  value: Input
  partnerId: string
}

export default Vue.extend<Data, {}, Computed, Props>({
  name: 'Store',
  components: {
    XFormLabel,
    Panel,
    StorePicker,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    partnerId: {
      type: String,
      required: true,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', { ...this.value, ...value })
      },
    },
  },
})
